"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSettingResponse = void 0;
var FieldSettingResponse = /** @class */ (function () {
    function FieldSettingResponse() {
        this.fieldName = '';
        this.settingKey = '';
        this.value = null;
    }
    return FieldSettingResponse;
}());
exports.FieldSettingResponse = FieldSettingResponse;
